<div
  class="assignment-uploader"
  fxLayout="column wrap"
  fxLayoutAlign="center center"
  >
  @if (!hideUrlForm) {
    <div>
      <button
        mat-raised-button
        [color]="activeButtonFile ? 'accent' : null"
        (click)="selectFileType()"
        >
        File
      </button>
      <button
        mat-raised-button
        [color]="activeButtonUrl ? 'accent' : null"
        (click)="selectUrlType()"
        >
        Url
      </button>
    </div>
  }
  @if (!isUploadingFile) {
    <div
      class="assignment-url"
      [formGroup]="uploadUrlForm"
      >
      <mat-form-field
        class="upload-url-form"
        style="background-color: #ffffff"
        >
        <mat-label>Enter Url</mat-label>
        <label>
          <input
            matInput
            trimInput
            type="text"
            formControlName="url"
            [(ngModel)]="urlToUpload"
            (input)="setUrlSubmission(urlToUpload)"
            />
        </label>
        <mat-icon matSuffix>link</mat-icon>
      </mat-form-field>
      <mat-error
        print-error
        [control]="uploadUrlForm.get('url')"
        fieldName="url"
        >
      </mat-error>
      @if (showUrlProgressBar) {
        <mat-progress-bar
          class="upload-url-progress-bar"
          mode="determinate"
          value="{{ uploader.queue[0]?.progress }}"
          >
        </mat-progress-bar>
      }
    </div>
  }

  @if (isUploadingFile) {
    <div
      ng2FileDrop
      (fileOver)="fileOverBase($event)"
      (onFileDrop)="fileSelected()"
      [uploader]="uploader"
      class="assignment-file-dropzone"
      >
      <h2>Drop File Here</h2>
      <p>Or, if you prefer...</p>
      <input
        type="file"
        ng2FileSelect
        placeholder=""
        #fileUploader
        [uploader]="uploader"
        [accept]="getMimeTypes()"
        [hidden]="true"
        (change)="onChange($event)"
        (onFileSelected)="fileSelected()"
        />
      <button
        id="file-select-button"
        class="file-select-button"
        mat-raised-button
        color="default"
        (click)="fileUploader.click()"
        >
        <mat-icon>folder_open</mat-icon>
        Select File
      </button>
      @if (showFileProgressBar) {
        <mat-progress-bar
          mode="determinate"
          value="{{ uploader.queue[0]?.progress }}"
          >
        </mat-progress-bar>
      }
      <div class="selected-file-name">
        <p>
          <strong>{{ uploader.queue[0]?.file?.name }}</strong>
          @if (uploader.queue?.length > 0) {
            <mat-icon
              class="clear-icon"
              (click)="clearSubmissionSet()"
              >clear</mat-icon
              >
            }
          </p>
        </div>
        @if (unsupportedFileType) {
          <span class="unsupported-file-container">
            Unsupported file type selected. Please select a file with the
            supported file type from the list below.
          </span>
        }
        @if (!imagesOnly) {
          <p class="helperText uploaderSupportText">
            <strong>Supported file types:</strong> word, excel, powerpoint, txt,
            pdf, jpg, jpeg, png, bmp, gif, mp4, mov, flv, webm, mp3, zip, max,
            gmx, gmz, unity3d, gameproj
          </p>
        }
        @if (imagesOnly) {
          <p class="helperText uploaderSupportText">
            <strong>Supported file types:</strong> jpg, jpeg, png, bmp, gif
          </p>
        }
        <p class="helperText uploaderSupportText">
          <strong>Max file size:</strong> 64MB
        </p>
      </div>
    }
  </div>
